import React, { Component } from "react";
import { Grid, Row, Col, Table, FormControl } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import LoadingSpinner from "views/Components/loadingSpinner";
import NotificationSystem from "react-notification-system";

import {
  getRandomStockCountMedicines,
  submitRandomStockCheck,
} from "../../../Listfunction";
import { style } from "../../../variables/Variables";

class DailyStockCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      assignments: [],
      dateKey: "",
      storageKey: "",
      unauthorized: false,
      usingDummyData: false,
      searchQuery: "",
      statusFilter: "all",
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem }, () => {
      this.loadDailyAssignments();
    });
  }

  getTodayKey = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  getStorageKey = (user, dateKey) => {
    const userIdentifier =
      user.id ||
      user.user_id ||
      user.email ||
      user.mobile ||
      user.name ||
      "user";
    return `daily_stock_check_${userIdentifier}_${dateKey}`;
  };

  parseJSON = (value, fallbackValue) => {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallbackValue;
    }
  };

  notify = (message, level = "success") => {
    if (!this.state._notificationSystem) {
      return;
    }

    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{message}</div>,
      level,
      position: "tr",
      autoDismiss: 6,
    });
  };

  getStoreWiseQuantity = (storeWiseMedication, type) => {
    if (!Array.isArray(storeWiseMedication)) {
      return 0;
    }

    const match = storeWiseMedication.find((item) => {
      const pharmacyName =
        item && item.pharmacies && item.pharmacies.name
          ? item.pharmacies.name
          : "";
      const name = pharmacyName.toLowerCase();
      if (type === "pharmacy") {
        return name.includes("pharmacy");
      }
      return name.includes("warehouse") || name.includes("store");
    });

    const fallback = storeWiseMedication.find(
      (item) => item && item.quantity !== undefined && item.quantity !== null,
    );

    const selectedStock = match || fallback;
    const quantity = Number((selectedStock && selectedStock.quantity) || 0);

    return Number.isNaN(quantity) ? 0 : quantity;
  };

  getRenderableValue = (value, fallbackValue = "") => {
    if (value === undefined || value === null) {
      return fallbackValue;
    }

    if (typeof value === "string" || typeof value === "number") {
      return value;
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    if (typeof value === "object") {
      return this.getFirstDefinedValue(
        value.quantity,
        value.total_quantity,
        value.in_stock,
        value.name,
        value.title,
        value.item_code,
        fallbackValue,
      );
    }

    return String(value);
  };

  normalizeStockCheckResponse = (response) => {
    const candidates = [
      response,
      response && response.data,
      response && response.data && response.data.items,
      response && response.items,
      response && response.results,
    ];

    return candidates.find((candidate) => Array.isArray(candidate)) || [];
  };

  getFirstDefinedValue = (...values) => {
    for (let index = 0; index < values.length; index += 1) {
      const value = values[index];
      if (value !== undefined && value !== null && value !== "") {
        return value;
      }
    }

    return "";
  };

  normalizeStockCheckItem = (item, index) => {
    item = item || {};
    const medication = item.medication || {};
    const id = item.id || item.medication_id || medication.id || index + 1;
    const medicationId = item.medication_id || medication.id || id;
    const storeWiseMedication = Array.isArray(medication.store_wise_medication)
      ? medication.store_wise_medication
      : [];

    return {
      id,
      medication_id: medicationId,
      item_code: medication.item_code || item.item_code || "",
      title: medication.title || item.title || "",
      pharmacyQty: this.getStoreWiseQuantity(storeWiseMedication, "pharmacy"),
      storeQty: this.getStoreWiseQuantity(storeWiseMedication, "store"),
      stock_count: this.getFirstDefinedValue(item.submitted_count, ""),
      note: item.mismatch_reason || "",
      checked_at: item.is_submitted
        ? item.submitted_at || item.updated_at
        : null,
    };
  };

  fetchMedicationPool = async (authToken) => {
    const response = await getRandomStockCountMedicines(authToken);
    const stockCheckItems = this.normalizeStockCheckResponse(response);

    return stockCheckItems.map(this.normalizeStockCheckItem);
  };

  pickRandomItems = (items, count) => {
    const shuffled = [...items];

    for (let i = shuffled.length - 1; i > 0; i -= 1) {
      const randomIndex = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[randomIndex]] = [
        shuffled[randomIndex],
        shuffled[i],
      ];
    }

    return shuffled.slice(0, Math.min(count, shuffled.length));
  };

  buildAssignmentsFromPool = (pool) => {
    const selected = pool.length > 10 ? this.pickRandomItems(pool, 10) : pool;

    return selected.map((item, index) => ({
      id: item.id,
      medicationId: item.medication_id || item.id,
      lineNo: index + 1,
      itemCode: this.getRenderableValue(item.item_code),
      title: this.getRenderableValue(item.title),
      pharmacyQty: this.getRenderableValue(item.pharmacyQty, 0),
      storeQty: this.getRenderableValue(item.storeQty, 0),
      stockCount: item.stock_count || "",
      note: item.note || "",
      checkedAt: item.checked_at || null,
    }));
  };

  normalizeCachedAssignment = (item, index) => {
    const assignment = item || {};

    return {
      ...assignment,
      id: assignment.id || assignment.medicationId || index + 1,
      medicationId:
        assignment.medicationId || assignment.medication_id || assignment.id,
      lineNo: assignment.lineNo || index + 1,
      itemCode: this.getRenderableValue(
        this.getFirstDefinedValue(assignment.itemCode, assignment.item_code),
      ),
      title: this.getRenderableValue(assignment.title),
      pharmacyQty: this.getRenderableValue(assignment.pharmacyQty, 0),
      storeQty: this.getRenderableValue(assignment.storeQty, 0),
      stockCount: this.getRenderableValue(
        this.getFirstDefinedValue(assignment.stockCount, assignment.stock_count),
      ),
      note: this.getRenderableValue(assignment.note),
      checkedAt: assignment.checkedAt || assignment.checked_at || null,
    };
  };

  getDummyAssignments = () => {
    const sampleMedicines = [
      { id: 9001, itemCode: "MED-0001", title: "Panadol 500mg" },
      { id: 9002, itemCode: "MED-0002", title: "Amoxicillin 250mg" },
      { id: 9003, itemCode: "MED-0003", title: "Cetirizine 10mg" },
      { id: 9004, itemCode: "MED-0004", title: "Metformin 500mg" },
      { id: 9005, itemCode: "MED-0005", title: "Atorvastatin 20mg" },
      { id: 9006, itemCode: "MED-0006", title: "Losartan 50mg" },
      { id: 9007, itemCode: "MED-0007", title: "Omeprazole 20mg" },
      { id: 9008, itemCode: "MED-0008", title: "Azithromycin 500mg" },
      { id: 9009, itemCode: "MED-0009", title: "Vitamin C 1000mg" },
      { id: 9010, itemCode: "MED-0010", title: "Calcium D3 Tablet" },
    ];

    return sampleMedicines.map((item, index) => ({
      id: item.id,
      medicationId: item.id,
      lineNo: index + 1,
      itemCode: item.itemCode,
      title: item.title,
      pharmacyQty: 20 + index,
      storeQty: 10 + index,
      stockCount: "",
      note: "",
      checkedAt: null,
    }));
  };

  loadDailyAssignments = async () => {
    const user = this.parseJSON(localStorage.getItem("user"), null);
    const dateKey = this.getTodayKey();

    if (!user || !user.token) {
      this.setState({
        loading: false,
        dateKey,
        assignments: this.getDummyAssignments(),
        usingDummyData: true,
      });
      return;
    }

    const role = Number(user.role);
    if (![11, 17, 18].includes(role)) {
      this.setState({
        loading: false,
        unauthorized: true,
        usingDummyData: false,
      });
      return;
    }

    const storageKey = this.getStorageKey(user, dateKey);
    const cachedValue = this.parseJSON(localStorage.getItem(storageKey), null);

    if (Array.isArray(cachedValue) && cachedValue.length > 0) {
      const assignments = cachedValue.map(this.normalizeCachedAssignment);
      localStorage.setItem(storageKey, JSON.stringify(assignments));

      this.setState({
        loading: false,
        dateKey,
        storageKey,
        assignments,
        usingDummyData: false,
      });
      return;
    }

    try {
      const medicationPool = await this.fetchMedicationPool(user.token);
      const assignments =
        medicationPool.length > 0
          ? this.buildAssignmentsFromPool(medicationPool)
          : this.getDummyAssignments();

      localStorage.setItem(storageKey, JSON.stringify(assignments));

      this.setState({
        loading: false,
        dateKey,
        storageKey,
        assignments,
        usingDummyData: medicationPool.length === 0,
      });

      if (medicationPool.length === 0) {
        this.notify("Loaded dummy stock-check data", "warning");
      }
    } catch (error) {
      this.setState({
        loading: false,
        dateKey,
        storageKey,
        assignments: this.getDummyAssignments(),
        usingDummyData: true,
      });
      this.notify(
        "Unable to load medicine list. Showing dummy stock-check data",
        "warning",
      );
    }
  };

  updateAssignment = (id, updates) => {
    this.setState(
      (prevState) => ({
        assignments: prevState.assignments.map((item) =>
          item.id === id ? { ...item, ...updates } : item,
        ),
      }),
      () => {
        if (this.state.storageKey) {
          localStorage.setItem(
            this.state.storageKey,
            JSON.stringify(this.state.assignments),
          );
        }
      },
    );
  };

  handleStockCountChange = (id, value) => {
    const sanitizedValue = value.replace(/[^0-9]/g, "");
    this.updateAssignment(id, { stockCount: sanitizedValue });
  };

  handleNoteChange = (id, value) => {
    this.updateAssignment(id, { note: value });
  };

  getFilteredAssignments = () => {
    const search = this.state.searchQuery.trim().toLowerCase();

    return this.state.assignments.filter((item) => {
      const isDone = !!item.checkedAt;
      if (this.state.statusFilter === "done" && !isDone) {
        return false;
      }
      if (this.state.statusFilter === "pending" && isDone) {
        return false;
      }

      if (!search) {
        return true;
      }

      const title = (item.title || "").toLowerCase();
      const code = (item.itemCode || "").toLowerCase();
      return title.includes(search) || code.includes(search);
    });
  };

  resetFilters = () => {
    this.setState({ searchQuery: "", statusFilter: "all" });
  };

  saveDraft = () => {
    if (this.state.storageKey) {
      localStorage.setItem(
        this.state.storageKey,
        JSON.stringify(this.state.assignments),
      );
      this.notify("Draft saved successfully");
    }
  };

  submitStockCheck = async () => {
    const user = this.parseJSON(localStorage.getItem("user"), null);
    if (!user || !user.token) {
      this.notify("User session not found", "error");
      return;
    }

    const items = this.state.assignments
      .filter((item) => item.stockCount !== "")
      .map((item) => ({
        medication_id: Number(item.medicationId || item.id),
        submitted_count: Number(item.stockCount),
      }));

    if (items.length === 0) {
      this.notify("Enter at least one counted stock before submit", "warning");
      return;
    }

    try {
      await submitRandomStockCheck(user.token, { items });

      const checkedAt = new Date().toISOString();
      const updatedAssignments = this.state.assignments.map((item) => ({
        ...item,
        checkedAt: item.stockCount ? checkedAt : item.checkedAt,
      }));

      this.setState({ assignments: updatedAssignments }, () => {
        if (this.state.storageKey) {
          localStorage.setItem(
            this.state.storageKey,
            JSON.stringify(this.state.assignments),
          );
        }
        this.notify("Stock check submitted for today");
      });
    } catch (error) {
      this.notify("Failed to submit stock check", "error");
    }
  };

  renderTableRows = (rows) => {
    if (rows.length === 0) {
      return (
        <tr>
          <td colSpan="8" className="text-center">
            No medicines found for the selected filter.
          </td>
        </tr>
      );
    }

    return rows.map((item) => (
      <tr key={item.id}>
        <td>{item.lineNo}</td>
        <td>{this.getRenderableValue(item.itemCode)}</td>
        <td>{this.getRenderableValue(item.title)}</td>
        <td>{this.getRenderableValue(item.pharmacyQty, 0)}</td>
        {/* <td>{item.storeQty}</td> */}
        <td style={{ width: "140px" }}>
          <FormControl
            type="text"
            value={item.stockCount}
            onChange={(event) =>
              this.handleStockCountChange(item.id, event.target.value)
            }
            placeholder="Count"
          />
        </td>
        <td style={{ minWidth: "200px" }}>
          <FormControl
            type="text"
            value={item.note}
            onChange={(event) =>
              this.handleNoteChange(item.id, event.target.value)
            }
            placeholder="Optional note"
          />
        </td>
        <td>
          <span
            className={
              item.checkedAt ? "label label-success" : "label label-warning"
            }
            style={{ fontSize: "11px" }}
          >
            {item.checkedAt ? "Done" : "Pending"}
          </span>
        </td>
      </tr>
    ));
  };

  render() {
    const completedCount = this.state.assignments.filter(
      (item) => !!item.checkedAt,
    ).length;
    const pendingCount = this.state.assignments.length - completedCount;
    const filteredAssignments = this.getFilteredAssignments();
    const summaryCardStyle = {
      border: "1px solid #e6e6e6",
      borderRadius: "6px",
      padding: "12px 14px",
      background: "#fff",
      height: "100%",
    };

    const toolbarStyle = {
      display: "flex",
      flexWrap: "wrap",
      gap: "12px",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "16px",
    };

    const buttonRowStyle = {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      flexWrap: "wrap",
      marginTop: "16px",
    };

    return (
      <div className="main-content">
        <NotificationSystem ref="notificationSystem" style={style} />
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Daily Stock Check"
                content={
                  <div style={{ paddingTop: "4px" }}>
                    {this.state.loading ? (
                      <LoadingSpinner />
                    ) : this.state.unauthorized ? (
                      <div className="text-danger">
                        You are not authorized to access this module.
                      </div>
                    ) : (
                      <div>
                        {this.state.usingDummyData && (
                          <div
                            className="alert alert-warning"
                            style={{ marginBottom: "14px" }}
                          >
                            Showing dummy data because live medicine data is
                            unavailable.
                          </div>
                        )}

                        <div style={toolbarStyle}>
                          <div style={{ minWidth: "240px" }}>
                            <h4 style={{ margin: 0, lineHeight: 1.2 }}>
                              Daily pharmacist stock verification
                            </h4>
                            <p style={{ margin: "6px 0 0", color: "#666" }}>
                              10 medicines are assigned each day for stock
                              count.
                            </p>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              flexWrap: "wrap",
                            }}
                          >
                            <div style={summaryCardStyle}>
                              <div style={{ fontSize: "12px", color: "#888" }}>
                                Date
                              </div>
                              <div
                                style={{ fontSize: "16px", fontWeight: 600 }}
                              >
                                {this.state.dateKey}
                              </div>
                            </div>
                            <div style={summaryCardStyle}>
                              <div style={{ fontSize: "12px", color: "#888" }}>
                                Assigned
                              </div>
                              <div
                                style={{ fontSize: "24px", fontWeight: 700 }}
                              >
                                {this.state.assignments.length}
                              </div>
                            </div>
                            <div style={summaryCardStyle}>
                              <div style={{ fontSize: "12px", color: "#888" }}>
                                Completed / Pending
                              </div>
                              <div
                                style={{ fontSize: "24px", fontWeight: 700 }}
                              >
                                {completedCount} / {pendingCount}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "12px",
                            alignItems: "center",
                            marginBottom: "14px",
                          }}
                        >
                          <div style={{ flex: "0 1 220px", minWidth: "180px" }}>
                            <FormControl
                              type="text"
                              value={this.state.searchQuery}
                              placeholder="Search by code or medicine"
                              onChange={(event) =>
                                this.setState({
                                  searchQuery: event.target.value,
                                })
                              }
                            />
                          </div>
                          <div style={{ width: "180px", maxWidth: "100%" }}>
                            <FormControl
                              componentClass="select"
                              value={this.state.statusFilter}
                              onChange={(event) =>
                                this.setState({
                                  statusFilter: event.target.value,
                                })
                              }
                            >
                              <option value="all">All</option>
                              <option value="pending">Pending</option>
                              <option value="done">Done</option>
                            </FormControl>
                          </div>
                          <div>
                            <Button
                              className="btn-fill btn btn-default"
                              onClick={this.resetFilters}
                            >
                              Reset Filters
                            </Button>
                          </div>
                        </div>

                        <Table responsive striped bordered hover>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Item Code</th>
                              <th>Medicine</th>
                              <th>Quantity</th>
                              {/* <th>Store Qty</th> */}
                              <th>Counted Stock</th>
                              <th>Note</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.renderTableRows(filteredAssignments)}
                          </tbody>
                        </Table>

                        <div style={buttonRowStyle}>
                          <Button
                            className="btn-fill btn btn-default"
                            onClick={this.saveDraft}
                          >
                            Save Draft
                          </Button>
                          <Button
                            className="btn-fill btn btn-success"
                            onClick={this.submitStockCheck}
                          >
                            Submit Stock Check
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default DailyStockCheck;
